// extracted by mini-css-extract-plugin
export var active = "_tb-1";
export var circle = "_tb-0";
export var completed = "_tb-2";
export var connector = "_tb-4";
export var connectorCompleted = "_tb-7";
export var connectorSpacer = "_tb-5";
export var iconStrokeOverride = "_tb-8";
export var labelContainer = "_tb-6";
export var pending = "_tb-3";